module.exports = __webpack_public_path__ + "static/media/sf-skyline-finish@3x.a818c189.png";